enum MvEcomIrwBagTypeEnum {
	irwCart = 'irw-shopping-cart',
	irwList = 'irw-shopping-list'
}

export default MvEcomIrwBagTypeEnum;
